'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselNavImageButton", {
    enumerable: true,
    get: function() {
        return CarouselNavImageButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarouselNavImageButton = require("./useCarouselNavImageButton");
const _renderCarouselNavImageButton = require("./renderCarouselNavImageButton");
const _useCarouselNavImageButtonStylesstyles = require("./useCarouselNavImageButtonStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CarouselNavImageButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselNavImageButton.useCarouselNavImageButton_unstable)(props, ref);
    (0, _useCarouselNavImageButtonStylesstyles.useCarouselNavImageButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselNavImageButtonStyles_unstable')(state);
    return (0, _renderCarouselNavImageButton.renderCarouselNavImageButton_unstable)(state);
});
CarouselNavImageButton.displayName = 'CarouselNavImageButton';
